<template>
    <div :class="['inline-flex justify-center items-center w-full', {'hidden': !isActive}]">
        <div :class="['p-1 px-2 m-2 mr-0 rounded border text-sm  font-semibold justify-center',  {
            'text-gdc-red-600 border-gdc-red-600' : this.filters.length > 0,
            'text-gdc-gray-350 border-gdc-gray-350': this.filters.length === 0
         }]" @click="clearFilters()">
            {{ clearLabelText }}
        </div>
        <div class="p-1 px-2 m-2 mr-0 rounded border border-gdc-gray-1000 bg-gdc-gray-1000
               text-sm text-white font-semibold justify-center" @click="$emit('saveFilters')">
            {{ saveLabelText.toUpperCase() }}
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterSubmit",
    /**
     * Component Props
     */
    props: {

        isActive: {
            type: Boolean,
            default:false
        },

        /**
         * Current Active filters
         */
        activeFilters: {
            type: Array
        }
    },

    computed:{
        /**
         * Clear Label Text
         * @return {*|string}
         */
        clearLabelText()
        {
            return window.translations?.slotGameFilters?.clear_label || 'CLEAR ALL';
        },

        /**
         * Save Label Text
         * @return {*|string}
         */
        saveLabelText()
        {
            return window.translations?.slotGameFilters?.save_label || 'Save';
        },
    },
    /**
     * Active Filters
     *
     * @return {{filters: *[]}}
     */
    data()
    {
        return {
            filters: [],
        }
    },

    methods:{

        /**
         * Clear All filters
         */
        clearFilters()
        {
            // loop through all filters and clear the is active status
            this.filters = this.filters.map((filter) =>
            {
                filter.is_active = false;
                return filter;
            });

            this.$emit('activeFiltersEvent');
        },
    },

    watch: {

        /**
         * when the prop data changed populate the two-way binding data
         * @param value
         */
        activeFilters(value)
        {
            this.filters = value;
        },
    }
}
</script>
